module.exports = __webpack_public_path__ + "media/images/CHA-08-df0abca1368d05b1ba1f8ce9d4efa6cc.jpg";